<template>
    <div id="pageContainer">
        <div class="content-cards" @scroll="handleScroll">
            <div class="cards-item" v-for="item in items" :key="item">
                <div class="item-left" @click="handleClick(item)">
                    <img :src="item.appIcon" alt="" />
                </div>
                <div class="item-right">
                    <div class="__header">
                        <div class="__local">
                            {{ item.isRemote == "1" ? "Host" : "Local" }}
                        </div>
                        <div class="__status">{{ item.statusName }}</div>
                    </div>

                    <div class="__title" @click="handleClick(item)">
                        {{ item.appName }}
                    </div>
                    <div class="__content" @click="handleClick(item)">
                        {{ item.appDesc }}
                    </div>
                    <div class="__label">{{ props.classType }}</div>
                    <div class="__bottom">
                        <div>@{{ item.createMan }}</div>
                        <div>
                            <svg
                                t="1756362374635"
                                class="icon"
                                viewBox="0 0 1092 1024"
                                version="1.1"
                                xmlns="http://www.w3.org/2000/svg"
                                p-id="17931"
                                width="10"
                                height="10"
                            >
                                <path
                                    d="M324.539733 0v392.260267H68.266667l468.992 406.869333 486.536533-406.869333H785.066667V0H324.539733zM0 992.6656h1092.266667V887.466667H0v105.198933z"
                                    fill="#99B4D6"
                                    p-id="17932"
                                ></path>
                            </svg>

                            {{ item.downloadTimes }}
                        </div>
                        <div>
                            <svg
                                t="1756362009717"
                                class="icon"
                                viewBox="0 0 1024 1024"
                                version="1.1"
                                xmlns="http://www.w3.org/2000/svg"
                                p-id="7688"
                                width="10"
                                height="10"
                            >
                                <path
                                    d="M928.445934 408.299453H664.597495C766.889116 29.804198 594.187335 10.458564 594.187335 10.458564c-73.155759 0-58.000776 58.036902-63.510037 67.736814 0 185.07504-196.183877 330.104075-196.183878 330.104075v524.860963c0 51.805116 70.46435 70.446287 98.100971 70.446287h396.431963c37.336532 0 67.700688-98.064844 67.700688-98.064844 98.064844-334.312789 98.064844-433.714306 98.064844-433.714306-0.018063-69.055424-66.345952-63.5281-66.345952-63.5281zM226.204833 408.462022H68.260646c-32.62205 0-33.163944 32.044029-33.163945 32.044028l32.603987 529.467067c0 33.633586 33.633586 33.633586 33.633586 33.633586h136.792239c28.503651 0 28.232704-22.271865 28.232704-22.271864V448.562216c0-40.660152-40.154383-40.100194-40.154384-40.100194z"
                                    fill="#FFA800"
                                    p-id="7689"
                                ></path>
                            </svg>
                            {{ item.likeTimes }}
                        </div>
                        <div>
                            <svg
                                t="1756362943296"
                                class="icon"
                                viewBox="0 0 1024 1024"
                                version="1.1"
                                xmlns="http://www.w3.org/2000/svg"
                                p-id="19962"
                                width="10"
                                height="10"
                            >
                                <path
                                    d="M512.092526 889.548815l-250.07132 127.559047a62.170407 62.170407 0 0 1-82.723213-24.941305 57.781908 57.781908 0 0 1-6.143899-37.667952l47.761501-270.258418L18.605776 492.901617A58.513324 58.513324 0 0 1 17.508651 408.861854a61.950982 61.950982 0 0 1 35.034853-17.334572l279.620549-39.423352 125.072231-245.829105a62.097266 62.097266 0 0 1 81.991796-26.98927 60.341866 60.341866 0 0 1 27.793829 26.98927l125.072231 245.829105 279.620549 39.423352a59.756733 59.756733 0 0 1 51.784292 67.363465 58.513324 58.513324 0 0 1-17.846564 34.01087l-202.309819 191.411712 47.761501 270.258417a59.610449 59.610449 0 0 1-49.95575 68.606873 62.828682 62.828682 0 0 1-38.83822-5.997616z"
                                    fill="#FFCA28"
                                    p-id="19963"
                                ></path></svg
                            >收藏
                        </div>
                        <div>
                            <svg
                                t="1756363354746"
                                class="icon"
                                viewBox="0 0 1024 1024"
                                version="1.1"
                                xmlns="http://www.w3.org/2000/svg"
                                p-id="31030"
                                width="10"
                                height="10"
                            >
                                <path
                                    d="M11.906977 686.144703C11.906977 815.040274 116.401033 919.527686 245.282364 919.527686 336.61059 919.527686 415.644553 867.07512 453.998997 790.654166L678.775475 830.246531 678.69434 836.171752C678.69434 928.249761 753.334677 1002.872594 845.396182 1002.872594 937.453687 1002.872594 1012.093023 928.249761 1012.093023 836.171752 1012.093023 744.092767 937.453687 669.475911 845.396182 669.475911 778.632502 669.475911 721.072771 708.661581 694.439626 765.323431L475.158671 726.724775C477.472673 713.56004 478.661727 699.982586 478.661727 686.144703 478.661727 625.213488 455.296238 569.751719 417.078034 528.208991L619.848371 325.417817C638.146084 332.321744 657.974439 336.079229 678.69434 336.079229 770.756846 336.079229 845.396182 261.456372 845.396182 169.383388 845.396182 77.310404 770.756846 2.686547 678.69434 2.686547 586.637836 2.686547 511.9985 77.310404 511.9985 169.383388 511.9985 216.140133 531.256868 258.382062 562.251562 288.660361L365.047879 485.862876C330.029199 464.866614 289.08725 452.76572 245.282364 452.76572 116.401033 452.771721 11.906977 557.249131 11.906977 686.144703L11.906977 686.144703 11.906977 686.144703Z"
                                    fill="#7A7A7A"
                                    p-id="31031"
                                ></path></svg
                            >分享
                        </div>
                        <button
                            class="button"
                            @click="editComponent(item)"
                            v-if="
                                proxy.$store.state.userID == item.creatorUID ||
                                proxy.$store.state.isAdmin == '1'
                            "
                        >
                            修改
                        </button>
                        <button
                            class="button-delete"
                            @click="delComponent(item)"
                            v-if="
                                proxy.$store.state.userID == item.creatorUID &&
                                item.status == '0'
                            "
                        >
                            删除
                        </button>
                    </div>
                </div>
            </div>
        </div>

        <!-- 加载更多提示 -->
        <div class="load-more" ref="loadMoreRef" v-if="props.loadMore">
            <span v-if="loadMore === 'pending'" @click="loadMoreData"
                >--- 加载更多 ---</span
            >
            <span v-else-if="loadMore === 'loading'">--- 正在加载 ---</span>
            <span v-else-if="loadMore === 'nomore'">已经到底了~ </span>
        </div>
    </div>
</template>

<script setup>
import {
    ref,
    onMounted,
    onUnmounted,
    defineProps,
    watch,
    getCurrentInstance,
    defineEmits,
} from "vue";

import QS from "qs";
import appDetails from "./appDetails.vue";
import { VXETable } from "vxe-table";
const { proxy } = getCurrentInstance();
const emit = defineEmits(["openEditComponent", "openDetailComponent"]);
const props = defineProps({
    loadMore: {
        type: Boolean,
        default: false,
    },
    queryType: {
        // 查询类型
        type: String,
        default: "",
    },
    searchStr: {
        type: String,
        default: "",
    },
    classType: {
        type: String,
        default: "",
    },
});

const items = ref([]); // 数据列表
const allData = ref({}); // 返回的所有数据
const loadMore = ref("pending"); // 加载状态：pending/loading/nomore
const page = ref(1); // 当前页码
const pageSize = 20; // 每页数据量
const totalItems = ref(0); // 总数据量（模拟）
const loadMoreRef = ref(null); // 加载更多元素的引用
import { message } from "ant-design-vue";
// 模拟异步加载数据
const fetchData = (pageNum, size) => {
    return new Promise((resolve) => {
        const params = {
            uid: proxy.$store.state.userID,
            email: "",
            currentPage: pageNum,
            pageSize: size,
            searchKey: [props.classType, props.queryType, props.searchStr], // ['类别名称','按label搜索', '按查询名称搜索']
        };
        console.log("fetchData params", params);
        proxy.$api.componentManageAPI
            .getComponentsList(QS.stringify(params))
            .then((res) => {
                console.log("getComponentsList", res.data.Data);
                if (res.data.Success) {
                    const data = res.data.Data.dataTable.all.all;
                    totalItems.value = res.data.Data.totalResult;
                    resolve(data);
                }
            });
    });
};
const loadMoreData = async () => {
    // eslint-disable-next-line curly
    if (loadMore.value === "nomore") return;

    try {
        loadMore.value = "loading";
        const newData = await fetchData(page.value, pageSize);

        if (newData.length > 0) {
            items.value = [...items.value, ...newData];
            page.value++;
        }

        if (items.value.length >= totalItems.value) {
            loadMore.value = "nomore";
        } else {
            loadMore.value = "pending";
        }
    } catch (error) {
        console.error("加载失败:", error);
        loadMore.value = "pending";
    }
};

const handleScroll = (e) => {
    console.log("滚动了", e);
};

const handleClick = (item) => {
    emit("openDetailComponent", item);
};
const editComponent = (item) => {
    emit("openEditComponent", item);
};

const delComponent = async (item) => {
    if (item.status != "0") {
        message.error("只能删除未审核的应用");
        return;
    }

    const type = await VXETable.modal.confirm("您确定要删除该数据吗?");
    if (type === "confirm") {
        const params = {
            Id: item.Id,
        };
        proxy.$api.componentManageAPI
            .delAPP(QS.stringify(params))
            .then((res) => {
                console.log("getComponentsListApi", res.data.Data);

                if (res.data.Success === false) {
                    VXETable.modal.message({
                        content: res.data.Message,
                        status: "error",
                    });
                    return;
                }
                VXETable.modal.message({
                    content: "删除成功",
                    status: "success",
                });
                items.value = [];
                page.value = 1;
                loadMore.value = "pending";
                loadMoreData(); // 加载第一页数据
            });
    }
};

// Intersection Observer 检测滚动
let observer;
onMounted(() => {
    observer = new IntersectionObserver(
        (entries) => {
            if (entries[0].isIntersecting && loadMore.value === "pending") {
                loadMoreData();
            }
        },
        { threshold: 0.1 } // 当元素进入视口 10% 时触发
    );
    if (loadMoreRef?.value) {
        observer.observe(loadMoreRef.value);
    }
});
onUnmounted(() => {
    if (observer) {
        observer.disconnect();
    }
});

// 监听queryType变化，重新加载数据
watch([() => props.queryType, () => props.searchStr], async () => {
    console.log(
        "queryType变化，重新加载数据",
        props.queryType,
        props.searchStr
    );

    page.value = 1; // 重置页码
    items.value = []; // 清空数据
    loadMore.value = "pending"; // 重置加载状态

    // 如果loadmore 为false，则不加

    await loadMoreData(); // 加载第一页数据
});
</script>

<style lang="scss" scoped>
.page-content {
    margin-top: 10px;

    .content-title {
        font-size: 20px;
        font-weight: 600;
        cursor: pointer;

        &:hover {
            color: #1d75fa;
        }
    }

    .content-cards {
        padding: 10px 0px;

        display: grid;
        grid-template-columns: repeat(3, 1fr);
        grid-gap: 20px;
        margin-top: 10px;
        cursor: pointer;

        .cards-item {
            display: flex;
            padding: 10px;
            background-color: #fff;
            border-radius: 0.5rem;
            box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);

            .item-left {
                margin-right: 10px;
                width: 56px;
                height: 56px;
                border-radius: 50%;
                overflow: hidden;
                background-color: transparent;
                margin-top: 30px;

                img {
                    width: 56px;
                    height: 56px;
                    border-radius: 50%;
                    object-fit: cover;
                    cursor: pointer;
                }
            }

            .item-right {
                flex: 1;
                display: flex;
                flex-direction: column; /* 垂直排列 */
                gap: 4px; /* 状态和标题的间距 */
                .__header {
                    display: flex;
                    justify-content: flex-end; /* 全部内容靠右 */
                    align-items: center;
                    gap: 6px; /* local 和 status 之间的间距 */
                    .__local {
                        font-size: 12px;
                        font-weight: normal;
                        color: #666;
                        background-color: #e6f2ff;
                        padding: 2px 6px;
                        border-radius: 4px;
                    }
                    .__status {
                        font-size: 12px;
                        font-weight: normal;
                        color: #666;
                        background-color: #e0e0e0;
                        padding: 2px 6px;
                        border-radius: 4px;
                    }
                }

                .__title {
                    display: flex; /* 左右布局 */
                    justify-content: space-between;
                    align-items: center;
                    font-size: 16px;
                    font-weight: 600;
                    color: #1e1f24;
                }

                .__content {
                    font-size: 14px;
                    color: #50525c;
                    //   超过两行省略
                    overflow: hidden;
                    text-overflow: ellipsis;
                    display: -webkit-box;
                    -webkit-line-clamp: 2;
                    -webkit-box-orient: vertical;
                }
                .__label {
                    font-size: 12px;
                    font-weight: normal;
                    color: #666;
                    background-color: #e0e0e0; /* 稍微深一点的灰底 */
                    padding: 2px 6px;
                    border-radius: 4px;
                    align-self: flex-start; /* 状态靠右 */
                }

                .__bottom {
                    display: flex;
                    //   justify-content: space-between;
                    align-items: center;
                    margin-top: 10px;
                    color: #848691;
                    font-size: 12px;
                    text-align: center;
                    line-height: normal;

                    div {
                        margin-right: 10px;
                        vertical-align: middle;
                    }
                    .button {
                        margin-left: 4px;
                        display: inline-block;
                        padding: 4px 6px;
                        font-size: 14px;
                        font-weight: 500;
                        color: #fff;
                        background-color: #28a745; /* 蓝色背景 */
                        border: none;
                        border-radius: 6px; /* 圆角 */
                        cursor: pointer;
                        transition: background-color 0.2s ease;
                    }

                    .button:hover {
                        background-color: #218838; /* hover 时加深 */
                    }

                    .button:active {
                        background-color: #1e7e34; /* 点击时更深 */
                    }

                    .button:disabled {
                        background-color: #ccc;
                        cursor: not-allowed;
                    }
                    .button-delete {
                        margin-left: 4px;
                        display: inline-block;
                        padding: 4px 6px;
                        font-size: 14px;
                        font-weight: 500;
                        color: #fff;
                        background-color: #dc3545; /* 红色背景 */
                        border: none;
                        border-radius: 6px; /* 圆角 */
                        cursor: pointer;
                        transition: background-color 0.2s ease;
                    }

                    .button-delete:hover {
                        background-color: #c82333; /* hover 时加深 */
                    }

                    .button-delete:active {
                        background-color: #bd2130; /* 点击时更深 */
                    }

                    .button-delete:disabled {
                        background-color: #ccc;
                        cursor: not-allowed;
                    }
                }
            }
        }
    }
}

// hover卡片时给图片增加放大效果
.cards-item:hover img {
    transform: scale(1.3);
    transition: transform 0.5s ease;
}

.load-more {
    width: 100%;
    text-align: center;
    color: #b7b9c1;
}
</style>
